import * as THREE from "three";
import {
  PRESET_GRID_MARKER_SIZE_PX,
  presetGridCenter360,
} from "../../../lib/presetGrid.ts";
import { patrolHotspotWorldPosition } from "./patrolHotspotProjection.js";
import { projectPatrolWorldToHostPx } from "./patrolPanoramaFocusRing.js";

const SPHERE_R = 100;

/** Max distance (px) from marker center to accept a canvas click on that preset box. */
const DEFAULT_MAX_PICK_DISTANCE_PX =
  PRESET_GRID_MARKER_SIZE_PX * 1.15 + 24;

/**
 * Find the saved preset grid cell whose on-screen marker is closest to the click.
 * Matches wankhede-360: move only when clicking a visible preset box, not a random point.
 */
export function pickNearestMappedPresetGridId({
  clientX,
  clientY,
  canvas,
  camera,
  hostEl,
  mappedGridIds,
  maxDistancePx = DEFAULT_MAX_PICK_DISTANCE_PX,
}) {
  if (!canvas || !camera || !hostEl || !mappedGridIds?.length) {
    return null;
  }

  const hostR = hostEl.getBoundingClientRect();
  const clickX = clientX - hostR.left;
  const clickY = clientY - hostR.top;

  let bestId = null;
  let bestDist = Infinity;

  for (const gridId of mappedGridIds) {
    const { yawDeg, pitchDeg } = presetGridCenter360(gridId);
    const world = new THREE.Vector3();
    patrolHotspotWorldPosition(yawDeg, pitchDeg, SPHERE_R, world);
    const proj = projectPatrolWorldToHostPx(canvas, camera, hostEl, world);
    if (!proj.visible) continue;

    const dx = clickX - proj.left;
    const dy = clickY - proj.top;
    const dist = Math.hypot(dx, dy);
    if (dist < bestDist) {
      bestDist = dist;
      bestId = gridId;
    }
  }

  if (bestId === null || bestDist > maxDistancePx) {
    return null;
  }
  return bestId;
}
